import { FlexRow, Panel, Text } from '@epam/promo';
import type { PreviewPanelProps } from './PreviewPanel.module';
import styles from './PreviewPanel.module.scss';

export const PreviewPanel = ({ children, headerAction }: PreviewPanelProps) => {
  return (
    <Panel shadow cx={styles.wrapper}>
      <FlexRow cx={styles.header} justifyContent="space-between" padding="12">
        <Text color="gray90" fontSize="18" fontWeight="600">
          Preview
        </Text>
        {headerAction}
      </FlexRow>
      {children}
    </Panel>
  );
};
